var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',_vm._b({attrs:{"label":"Slider","hint":"hint"}},'v-slider',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }